var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "c-factlist" }, [
    _c("h3", { staticClass: "c-factlist__title" }, [_vm._v("Fakta")]),
    _vm._v(" "),
    _c("ul", { staticClass: "c-factlist__list" }, [
      _vm.residenceType.name
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Boligtype:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.residenceType.name))]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.bedrooms
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Soverom:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.facts.bedrooms))]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.bathrooms
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Bad:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.facts.bathrooms))]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.jointCosts && _vm.availability.slug !== "sold"
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Felleskostnader:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.facts.jointCosts.toLocaleString("nb-NO")) + " kr"
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.size
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Bruksareal:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.facts.size.toLocaleString("nb-NO")) + " m²"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.floorSize
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("P-rom:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.facts.floorSize.toLocaleString("nb-NO")) + " m²"
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.grossSize
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Bruttoareal:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.facts.grossSize.toLocaleString("nb-NO")) + " m²"
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.bra_i
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("BRA-i:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.facts.bra_i.toLocaleString("nb-NO")) + " m²"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.bra_e
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("BRA-e:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.facts.bra_e.toLocaleString("nb-NO")) + " m²"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.bra_b
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("BRA-b:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.facts.bra_b.toLocaleString("nb-NO")) + " m²"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.tba
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Terrasse- og balkongareal (åpent areal):")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.facts.tba.toLocaleString("nb-NO")) + " m²"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.alh
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Areal med lav himlingshøyde:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.facts.alh.toLocaleString("nb-NO")) + " m²"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.gua
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Gulvareal:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.facts.gua.toLocaleString("nb-NO")) + " m²"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.storage
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Bod:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.facts.storage) + " m²")]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.plotsize
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Tomteareal:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.facts.plotsize) + " m²")]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.floor
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Etasje:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.facts.floor))]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.terrace
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Terrasse:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.facts.terrace) + " m²")]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.balcony
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Balkong:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.facts.balcony) + " m²")]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.glazed_balcony
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Innglasset balkong:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.facts.glazed_balcony) + " m²")]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.garden
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Hage:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.facts.garden) + " m²")]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.garage && _vm.availability.slug !== "sold"
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Garasje:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.garage))]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.carport && _vm.availability.slug !== "sold"
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Carport:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.carport))]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.facts.parking && _vm.availability.slug !== "sold"
        ? _c(
            "li",
            { staticClass: "c-factlist__item c-factlist__item--border" },
            [
              _c("span", [_vm._v("Parkering:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.facts.parking))]),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }